import { authRoles } from 'app/auth';
import VonalkodTesztlapTable from 'app/admin/vonalkodtesztlap/table/VonalkodTesztlapTable';
import VonalkodTesztlapEditForm from 'app/admin/vonalkodtesztlap/editform/VonalkodTesztlapEditForm';

export default [
	{
		path: '/vonalkodtesztlap/edit/:id',
		component: VonalkodTesztlapEditForm,
		auth: authRoles.szervezo
	},
	{
		path: '/vonalkodtesztlap/:sessionNameParam?',
		component: VonalkodTesztlapTable,
		auth: authRoles.szervezo
	}
];
